import * as gs from "@ivanlog/gs";
import { CmpTableItemLPX, CmpWidgetLPXTableBase } from "./tmpls";
import { LPXInfrastructure } from "../contracts/LPXInfrastructure";
import { App } from "../App";
import { Web3Helper } from "../libs/Web3Helper";
import { BiMath } from "../libs/BiMath";
import { CmpWidgetLPXDetails } from "./CmpWidgetLPXDetails";
import { LPXInfo } from "../api/classes/models";
import { CmpWidgetChart } from "./CmpWidgetChart";
import { CmpWidgetLPXCtrl } from "./CmpWidgetLPXCtrl";

type LPXTableRow = {
    item: CmpTableItemLPX;
    pool:LPXInfo|undefined
};

export class CmpWidgetLPXTable extends CmpWidgetLPXTableBase {
    private static readonly PAGE_SIZE = 15;

    private _lpxInf:LPXInfrastructure;
    private _cmpDetails:CmpWidgetLPXDetails;
    private _cmpChart:CmpWidgetChart;
    private _cmpLiq:CmpWidgetLPXCtrl;

    private _rows:LPXTableRow[]=[];
    private _rowsByPoolId = new Map<number, LPXTableRow>();
    private _selectedOblivionPoolIds = new Set<number>();

    private _currentPage = 1;
    private _filterPortfolio=false;        //где пользователь стейкер
    private _filterManager=false;   //где пользователь менеджер
    private _filterSolo=false;   //где пользователь менеджер

    constructor() {
        super();
        this.disable();

        //this.ctrls.btnNewLPX.disable();

        this.ctrls.btnPagePrev.onclick = async ()=>{
            if (this._currentPage<=1) return;
            this._currentPage--;
            await this._loadSelectedPageAsync();
        };
        this.ctrls.btnPageNext.onclick = async ()=>{
            if (this._rows.length<CmpWidgetLPXTable.PAGE_SIZE) return;
            //TODO если в списке меньше чем макс то не давать следующий шаг
            this._currentPage++;
            await this._loadSelectedPageAsync();
        };
        this.ctrls.btnFilterPortfolio.onclick=async ()=>{
            this.ctrls.btnFilterPortfolio.activeFlip();
            this._filterPortfolio=this.ctrls.btnFilterPortfolio.isActive;
            this._currentPage=1;
            await this._loadSelectedPageAsync();
        }
        this.ctrls.btnFilterManager.onclick=async ()=>{
            this.ctrls.btnFilterManager.activeFlip();
            this._filterManager=this.ctrls.btnFilterManager.isActive;
            this._currentPage=1;
            await this._loadSelectedPageAsync();
        }

        this.ctrls.btnFilterSolo.onclick=async ()=>{
            this.ctrls.btnFilterSolo.activeFlip();
            if (this.ctrls.btnFilterSolo.isActive)
            {
                const auth = await this._lpxInf.authorizeAsync();
                if (!auth) {this.ctrls.btnFilterSolo.inactive(); return;}
            }
            this._filterSolo=this.ctrls.btnFilterSolo.isActive;
            this._currentPage=1;
            await this._loadSelectedPageAsync();
        }

        this.ctrls.btnConnect.onclick=async ()=>{
            this.ctrls.btnConnect.disable();
            await App.chain.tryConnectAsync();
            this.ctrls.btnConnect.enable();
        }

        this.ctrls.btnForgetSelected.onclick=async ()=>{
            if (!this._isOblivionSelectionMode()) return;
            const poolIds = Array.from(this._selectedOblivionPoolIds);
            if (poolIds.length==0) return;

            const countText = poolIds.length==1 ? "pool" : "pools";
            const confirm = await App.gui.dialogOkNoShowAsync(`Forget ${poolIds.length} selected inactive LPX ${countText}?`);
            if (!confirm) return;

            await App.gui.awaitInLockUIAsync((async ()=>{
                const result = await this._lpxInf.lpxCtrlPoolMngr.managerSetPoolsFlagAsync(poolIds, LPXInfrastructure.PACKFLAG_POOL_OBLIVION, true);
                if (result) App.gui.dialogOkShowAsync("Transaction successful!","");
                if (result) this._selectedOblivionPoolIds.clear();
                await this._lpxInf.refreshAsync();
            })());
        }

        this.ctrls.cmpSearch.ctrls.iSearch.el.oninput=async (e)=>{
            let value = this.ctrls.cmpSearch.ctrls.iSearch.value.trim();
            if (value.length>=2||value=="")
            {
                this._currentPage=1;
                await this._loadSelectedPageAsync(value);
            } 
        }

        this._currentPage = 1;
    }

    public async refreshAsync(cmpDetails:CmpWidgetLPXDetails, cmpChart:CmpWidgetChart, cmpLiq:CmpWidgetLPXCtrl)
    {
        this._cmpDetails=cmpDetails;
        this._cmpChart = cmpChart;
        this._cmpLiq=cmpLiq;
        this._lpxInf = App.Inst.getInst(LPXInfrastructure);

        for(const row of this._rows) row.item.cut();
        gs.array.clear(this._rows);
        this._rowsByPoolId.clear();
        await this._loadSelectedPageAsync();

        this.enable();
        this.ctrls.blockConnect.show();
        this.ctrls.blockNewLPX.hide()
        if (App.chain.account) {this.ctrls.blockConnect.hide(); this.ctrls.blockNewLPX.show()}
    }

    private async _loadSelectedPageAsync(searchQuery="")
    {
        this._selectedOblivionPoolIds.clear();
        this._refreshOblivionControls();
        this.ctrls.cmpSearch.ctrls.iSearch.value=searchQuery;
        this.ctrls.lPage.text="Page "+this._currentPage;
        const pageSize = CmpWidgetLPXTable.PAGE_SIZE;
        this.ctrls.btnPageNext.disable();
        this.ctrls.btnPagePrev.disable();
        const pools = await this._lpxInf.getLPXsAsync((this._currentPage-1)*pageSize, pageSize, searchQuery, this._filterPortfolio, this._filterManager, this._filterSolo);
        if (this._filterSolo&&!this._lpxInf.hasAuthState())
        {
            this._filterSolo=false;
            this.ctrls.btnFilterSolo.inactive();
        }
        this.ctrls.btnPageNext.enable();
        this.ctrls.btnPagePrev.enable();
        for(const r of this._rows) r.item.cut();
        this._rows=[];
        this._rowsByPoolId.clear();
        if (this._currentPage==1) this.ctrls.btnPagePrev.disable();
        else this.ctrls.btnPagePrev.enable();
        if (!pools) {this._refreshOblivionControls(); return;}
        for(const pool of pools)
        {
//            if (config.pack==0n) continue;
            // if (this._lpxInf.hasFlag(config.pack, LPXInfrastructure.PACKFLAG_MANAGER_ONLY))
            // {
            //     if (!account) continue;
            //     if (config.manager.toLowerCase()!=account.toLocaleLowerCase() &&
            //         account.toLocaleLowerCase()!=LPXInfrastructure.ADDRESS_DEBUG.toLocaleLowerCase())
            //         continue;
            // }

          //  const fundAdr = this._lpxInf.pAdrToAdr(config.fundToken);
        //    const anchorAdr = this._lpxInf.pAdrToAdr(config.anchorToken);

            const item = new CmpTableItemLPX();
            let fs = pool.fundToken.symbol;
            let as = pool.anchorToken.symbol;
            if (fs.length>8) fs = fs.substring(0,6)+"..";
            if (as.length>8) as = as.substring(0,6)+"..";
            item.ctrls.lSymbols.text = fs+"/"+as;
            const fundDecimal = BiMath.Pow10(pool.fundToken.decimals);
            const anchorDecimal = BiMath.Pow10(pool.anchorToken.decimals);
            item.ctrls.lReserveFund.text = Web3Helper.ToLargeNumberUnit(BiMath.WEIToBI(pool.reserves.fundRaw)*BiMath.Decimal/fundDecimal);
            item.ctrls.lReserveAnchor.text = Web3Helper.ToLargeNumberUnit(BiMath.WEIToBI(pool.reserves.anchorRaw)*BiMath.Decimal/anchorDecimal);
            item.ctrls.lAPR.text = "-";
            if (pool.apr30d) item.ctrls.lAPR.text = Math.trunc(pool.apr30d*1000)/10+"%";
            this.ctrls.list.append(item);

            const row:LPXTableRow = { item, pool };
            this._rows.push(row);
            this._rowsByPoolId.set(pool.poolId, row);
            item.onclick=async()=> await this._selectPoolAsync(row);
            item.ctrls.cellForget.onclick=(e)=>gs.events.stop(e);
            item.ctrls.btnForget.onclick=(e)=>{
                gs.events.stop(e);
                if (!this._isOblivionSelectionMode()) return;
                if (!this._canSelectForOblivion(row)) return;

                if (this._selectedOblivionPoolIds.has(pool.poolId))
                    this._selectedOblivionPoolIds.delete(pool.poolId);
                else
                    this._selectedOblivionPoolIds.add(pool.poolId);
                this._refreshOblivionControls();
            }
            
        }
        if (this._rows.length>0)this._rows[0].item.el.click();
        if (this._rows.length<CmpWidgetLPXTable.PAGE_SIZE) this.ctrls.btnPageNext.disable();
        else this.ctrls.btnPageNext.enable();
        while(this._rows.length!=15)
        {
            const item = new CmpTableItemLPX();
            item.ctrls.lSymbols.text="-";
            item.ctrls.lReserveFund.text="";
            item.ctrls.lReserveAnchor.text="";
            item.ctrls.lAPR.text="";
            this.ctrls.list.append(item);
            const row:LPXTableRow = { item, pool:undefined };
            this._rows.push(row);
        }
        this._refreshOblivionControls();
    }
    
    private async _selectPoolAsync(row:LPXTableRow)
    {
        if (!row.pool) return;
        for(const r of this._rows) r.item.inactive();
        row.item.active();
        try
        {
            const pool = row.pool;
            this.ctrls.list.disable();

            if (pool.sharesTotalRaw=="0") 
                this._cmpChart.hide();
            else
            {
                this._cmpChart.show();
                this._cmpChart.loadLPXAsync(pool)
            }
            await this._cmpDetails.refreshAsync(pool);
            await this._cmpLiq.refreshAsync(pool);
        } catch(ex)
        {
            console.error(ex);
        }
        this.ctrls.list.enable();
    }

    private _refreshOblivionControls()
    {
        const isSelectionMode = this._isOblivionSelectionMode();
        if (isSelectionMode) this.ctrls.header.ctrls.cellForget.show();
        else this.ctrls.header.ctrls.cellForget.hide();

        for(const row of this._rows)
        {
            row.item.removeClass("forget-selected");
            row.item.ctrls.btnForget.inactive();
            if (!isSelectionMode)
            {
                row.item.ctrls.cellForget.hide();
                continue;
            }

            row.item.ctrls.cellForget.show();
            if (!row.pool)
            {
                row.item.ctrls.btnForget.hide();
                continue;
            }

            const canSelect = this._canSelectForOblivion(row);
            if (!canSelect)
            {
                row.item.ctrls.btnForget.hide();
                continue;
            }

            row.item.ctrls.btnForget.show();
            row.item.ctrls.btnForget.enable();

            if (this._selectedOblivionPoolIds.has(row.pool.poolId))
            {
                row.item.addClass("forget-selected");
                row.item.ctrls.btnForget.active();
            }
        }

        const selectedCount = this._selectedOblivionPoolIds.size;
        this.ctrls.btnForgetSelected.text = selectedCount>0 ? `Forget Selected (${selectedCount})` : "Forget Selected";
        this.ctrls.btnForgetSelected.enableSet(selectedCount>0);
        if (isSelectionMode && selectedCount>0) this.ctrls.btnForgetSelected.show();
        else this.ctrls.btnForgetSelected.hide();
    }

    private _isOblivionSelectionMode()
    {
        return this._filterManager || this._filterSolo;
    }

    private _canSelectForOblivion(row:LPXTableRow)
    {
        if (!row.pool) return false;
        return BiMath.WEIToBI(row.pool.sharesTotalRaw)==0n;
    }
}
